import { render, staticRenderFns } from "./BaseForm.vue?vue&type=template&id=3ead5cb6&scoped=true"
import script from "./BaseForm.vue?vue&type=script&lang=js"
export * from "./BaseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ead5cb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ead5cb6')) {
      api.createRecord('3ead5cb6', component.options)
    } else {
      api.reload('3ead5cb6', component.options)
    }
    module.hot.accept("./BaseForm.vue?vue&type=template&id=3ead5cb6&scoped=true", function () {
      api.rerender('3ead5cb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/investments/fee-schedule-list-manager/BaseForm.vue"
export default component.exports